<div class="page-detail">
    <div class="page-detail-content">
        <div class="page-container">
            <span class="page-title">Account/Report Maintenance</span>
        </div>
        <div class="account-maintenance">
            <form>
                <div class="formTable">
                    <div class="tooltip">
                        <input class="formField" [(ngModel)]="searchTerm" name="searchCriteria">
                        <span class="tooltiptext">Find account</span>
                    </div>
                </div>
                <input type="submit" (click)="onSearch()" value="Submit" placeholder="Find an account"/>
                @if (noResultsFound) {
                    <span style="color: red; padding-left: 20px;">No account was found.</span>
                }
                <div style="clear: both; height: 10px; display: block;"></div>
            </form>
            <div style="display: table; width: 100%;">
                <div style="display: table-row;">
                    <div style="width: 50%; display: table-cell; vertical-align: top; padding-right: 10px;">
                        <table mat-table [dataSource]="accountDataSource" matSort>
                            <ng-container matColumnDef="accountNumber">
                                <td mat-header-cell *matHeaderCellDef>Account</td>
                                <td mat-cell mat-cell *matCellDef="let account">
                                    <span style="color: #999999">{{account.AccountNumber}}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="accountName">
                                <th mat-header-cell *matHeaderCellDef>Name</th>
                                <td mat-cell *matCellDef="let account">{{account.Name}}</td>
                            </ng-container>
                            <ng-container matColumnDef="accountLocation">
                                <th mat-header-cell *matHeaderCellDef>Location</th>
                                <td mat-cell *matCellDef="let account">{{account.Location}}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="accountDisplayColumns; sticky: true" class="gridRowHeading"></tr>

                            <tr mat-row *matRowDef="let account; columns: accountDisplayColumns"
                                class="list-data-row" [class.account-selected]="account == currentAccount"
                                style="height: auto;" (click)="onAccountSelected(account)">
                            </tr>
                        </table>
                        <mat-paginator name="accountPaginator" [hidePageSize]="true" [pageSize]="20" showFirstLastButtons="true"></mat-paginator>
                    </div>
                    <div style="width: 50%; display: table-cell; vertical-align: top; padding-right: 10px;">
                        <table mat-table [dataSource]="reportDataSource" matSort enabled="isAccountSelected">
                            <ng-container matColumnDef="reportSelected">
                                <td mat-header-cell *matHeaderCellDef></td>
                                <td mat-cell *matCellDef="let report">
                                    @if (report.isSelected) {
                                        <mat-icon class="report-check">check_box</mat-icon>
                                    } @else {
                                        <mat-icon class="report-check">check_box_outline_blank</mat-icon>
                                    }
                                    <!-- <mat-checkbox [checked]="report.isSelected"
                                        (change)="toggleReportSelection(report, $event)"
                                        class="report-check">
                                    </mat-checkbox> -->
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="reportId">
                                <td mat-header-cell *matHeaderCellDef>Id</td>
                                <td mat-cell mat-cell *matCellDef="let report">
                                    <span style="color: #999999">{{report.report.Id}}</span>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="reportName">
                                <th mat-header-cell *matHeaderCellDef>Name</th>
                                <td mat-cell *matCellDef="let report">{{report.report.Name}}</td>
                            </ng-container>
                            <ng-container matColumnDef="reportDescription">
                                <th mat-header-cell *matHeaderCellDef>Description</th>
                                <td mat-cell *matCellDef="let report">{{report.report.Description}}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="reportDisplayColumns; sticky: true" class="gridRowHeading"></tr>

                            <tr mat-row *matRowDef="let report; columns: reportDisplayColumns"
                                class="list-data-row" style="height: auto;" [class.disabled]="!isAccountSelected" (click)="toggleReportSelection(report)">
                            </tr>
                        </table>
                        <mat-paginator name="reportPaginator" [hidePageSize]="true" [pageSize]="20" showFirstLastButtons="true"></mat-paginator>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
